module.exports = __webpack_public_path__ + "static/media/no_invitations.c0606a88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/no_invitations.svg
// module id = 1275
// module chunks = 0